import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { shopInfo } from '../data/mock';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src={shopInfo.logo} 
              alt="Global Boutique Logo" 
              className="h-16 w-auto"
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('about')}
              className="nav-link"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="nav-link"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('collection')}
              className="nav-link"
            >
              Collection
            </button>
            <button 
              onClick={() => scrollToSection('pricing')}
              className="nav-link"
            >
              Pricing
            </button>
            <button 
              onClick={() => scrollToSection('gallery')}
              className="nav-link"
            >
              Gallery
            </button>
            <button 
              onClick={() => scrollToSection('reviews')}
              className="nav-link"
            >
              Reviews
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="nav-link"
            >
              Contact
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6 text-gray-800" />
            ) : (
              <Menu className="h-6 w-6 text-gray-800" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('about')}
                className="mobile-nav-link"
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="mobile-nav-link"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('collection')}
                className="mobile-nav-link"
              >
                Collection
              </button>
              <button 
                onClick={() => scrollToSection('pricing')}
                className="mobile-nav-link"
              >
                Pricing
              </button>
              <button 
                onClick={() => scrollToSection('gallery')}
                className="mobile-nav-link"
              >
                Gallery
              </button>
              <button 
                onClick={() => scrollToSection('reviews')}
                className="mobile-nav-link"
              >
                Reviews
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="mobile-nav-link"
              >
                Contact
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
